<!-- src/components/OkDialog.vue -->
<template>
  <v-dialog 
    v-model="isVisible" 
    max-width="400px" 
    @keydown.esc="onOk ? handleCancel : null"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="onOk" color="grey" text @click="handleCancel">Cancel</v-btn>
        <v-btn color="primary" text @click="handleOk">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OkDialog',
  props: {
    title: {
      type: String,
      default: 'Information'
    },
    message: {
      type: String,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    onOk: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      isVisible: true
    };
  },
  methods: {
    handleOk() {
      this.isVisible = false;
      if (this.onOk) {
        this.onOk();
      }
      this.onClose();
    },
    handleCancel() {
      this.isVisible = false;
      this.onClose();
    }
  }
};
</script>

<style scoped>
:deep(a[href^="tel:"]) {
  color: #1976d2; /* Vuetify primary color */
  text-decoration: none;
}

:deep(a[href^="tel:"]:hover) {
  text-decoration: underline;
}
</style>

